import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const productsJswConfigurationRoute: InvariantJiraRoute = {
	name: 'products-jsw-configuration',
	path: '/jira/settings/products/jira-software-configuration',
	exact: true,
};
